import {
  getFirestore,
  onSnapshot,
  doc,
  where,
  query,
  getDoc,
  getDocs,
  updateDoc,
  collection,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import lodash from "lodash";
import moment from "moment";
import { TYPES } from "./discount.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------- add Staff  ------------- //

export const addDiscountNotes =
  ({ data }, callback) =>
  (dispatch) => {
    let date = data?.date;
    const cRef = collection(firestore, REF.DISCOUNT);
    const c0 = where("date", "==", date);
    const branch = data?.branch;
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const dataNotes = snapshot.docs.map((doc) => doc.data());

        //Có dữ liệu, update lại
        if (dataNotes?.length > 0) {
          let detail = dataNotes[0];
          let id = detail?.id;
          let notes = data?.notes;
          const dRef = doc(cRef, id);
          let update = {
            notes,
          };

          updateDoc(dRef, update)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          //Tạo mới dữ liệu.
          let onDate = moment(date, "DD/MM/YYYY")?.toDate();
          let id = doc(cRef).id;
          const dRef = doc(cRef, id);
          let created = {
            ...data,
            id,
            onDate,
            createAt: serverTimestamp(),
          };

          //   console.log({ created });

          setDoc(dRef, created, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        }
      }
    });
  };

// -------------- snap All Notes  ------------- //
let discountSub = [];
export const snapAllDiscount =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectAllDiscountSuccess(dispatch, null);
    const cRef = collection(firestore, REF.DISCOUNT);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data?.length > 0) {
          const detail = data[0];
          selectAllDiscountSuccess(dispatch, detail);
          if (callback) {
            callback(detail);
          }
        } else {
          callback(false);
        }
      }
    });

    discountSub.push(unsub);
  };

export const unSnapDiscount = () => (dispatch) => {
  discountSub.forEach((subscriber) => {
    subscriber();
  });
  discountSub.length = 0;
};

// -------------- dispatch  ------------- //
const selectAllDiscountSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_DISCOUNT_SUCCESS,
    payload: data,
  });
};
